import React from "react";
import { Form, Input, message, Typography, List, Divider, Checkbox, Alert, Button, Popconfirm} from "antd";
import api from "utils/api";
import { currentTab } from "store/slice/tabs-slice";
import utils from "utils";
import Loader from "Components/Loader";
import { Select } from "antd";
const placeholder = "Type here...";
import { connect } from "react-redux";
import TodoItem from "./TodoItem";
import "./Diagnosis.scss";
import SubmitButton from '../Patient/SubmitButton'
import debounce from "lodash.debounce";
import { CONSTANTS } from "utils/constant";

const { Text, Link } = Typography;
class Diagnosis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      update_diagnosis: false,
      isLoading: true,
      isDiagnosis_filled: false,
      search_suggestion: [],
      retain_suggession: [],
      diagnosisName: [],
      search_suggestion: [],
      selectedValue: [],
      provisional_diagnosis: [],
      differential_diagnosis: [],
      final_diagnosis: [],
      myPatients: this.props.myPatients,
      retain_suggession: this.props?.retain_suggession || [],
      icd_suggession: this.props?.retain_suggession || [],
      icd_group: [],
      is_loading: true,
      provisional_diagnosis_1:[],
      buttonLoading : true,
      is_editable : this.props?.is_editable != undefined ? this.props?.is_editable : true,
      checkbox_options: [],
      checkbox_length: true,
      finalDiagnosis_checkbox: [],
      enable_finalDiagnosis: true,
      checkbox_checked: false,
      selected_array:[]
    };
    this.form = React.createRef();
    this.handleOnSearch = this.handleOnSearch.bind(this);
    this.debouncedFunction = this.debouncedFunction.bind(this);
  }

  componentDidMount() {
    // console.log(typeof this.props.formAction)
    typeof this.props.formAction == "function" && this.props.formAction(false);
    this.getDefaultIcdList();
    this.getDiagnosisConsultation();
  }
  getDiagnosisConsultation() {
    let data = {
      app_id: this.props?.data?.appointment_id,
      type: "diagnosis",
    };
    api
      .get_new_consultation_details(data)
      .then(async (response) => {
        let diagnosis = response.data.data?.results?.diagnosis;
        this.setState({ ...diagnosis, isLoading: false});
        // let diagnosis_selected = diagnosis[0]?.final_diagnosis_check_box?.filter(item => item.is_selected).map(item=> item.name)
        // this.setState({selected_array: diagnosis_selected || [], checkbox_length: diagnosis_selected?.length})
        // if (diagnosis_selected?.length === 6){
        //   this.setState({enable_finalDiagnosis: false, checkbox_checked: true})
        // }
        if (diagnosis.length == 0) {
          await this.getDiagnosisQuestions();
          return;
        }
        this.getDiagnosisQuestions(diagnosis[0], true);
      })
      .catch(() => {});
  }
  getDiagnosisQuestions(val, flag= false) {
    api
      .get_new_diagnosis(
        this?.props?.data?.user_type,
        this?.props?.data?.appointment_id
      )
      .then((res) => {
        let {
          status,
          data: { results },
        } = res.data || {};
        if (status == 200) {
          this.setState({buttonLoading: false})
          if(!flag){
            this.setState({checkbox_options: results[0].data?.final_diagnosis_check_box})
            let diagnosis_selected = results[0].data?.final_diagnosis_check_box?.filter(item => item.is_selected).map(item=> item.name)
            this.setState({selected_array: diagnosis_selected || [], checkbox_length: diagnosis_selected?.length})
            if(diagnosis_selected?.length === 6){
              this.setState({enable_finalDiagnosis: false, checkbox_checked: true})
            }
          }
          if (results[0].data?.finding_from_dsm?.length > 0) {
            let dsmValue = results[0].data?.finding_from_dsm;
            const capitalizeDSMValue = dsmValue.map((name) => {
              return name[0].toUpperCase() + name.slice(1);
            });
            // if (flag) val.finding_from_dsm = capitalizeDSMValue;
          }
        }
        if (flag) {
          delete val["is_completed"];
          delete val["completion_date"];
          delete val["type"];
          this.setState({
            diagnosis_question_list: val,
            isLoading: false,
            update_diagnosis: true,
            ...val,
          });
          // this.form.current?.setFieldsValue({
          //   finding_from_dsm:
          //     this.state.diagnosis_question_list?.finding_from_dsm?.join("\n"),
          // });
        } else {
          this.setState({
            diagnosis_question_list: results[0].data,
            isLoading: false,
            ...results[0].data,
          });
          // this.form.current?.setFieldsValue({
          //   finding_from_dsm:
          //     this.state.diagnosis_question_list?.finding_from_dsm?.join("\n"),
          // });
        }
      });
  }
  getDefaultIcdList(val,type) {

    api
      .get_default_icd_list()
      .then((res) => {
        let icd_suggest = res.data.data.results.map((i) => {
          return {
            type: i.type,
            diagnosis: i.diagnosis,
            code: i.code,
            diagnosis_with_code: i.code
              ? i.diagnosis + "(" + i.code + ")"
              : i.diagnosis,
          };
        });

        this.setState({ icd_suggession: icd_suggest,[`${type}_1`]:icd_suggest });
        let group = [];
        Object.values(this.state.icd_suggession).map((i, j) => {
          group = Object.values(this.state.icd_suggession).reduce(
            (acc, item) => {
              if (!acc[item.type]) {
                acc[item.type] = [];
              }
              acc[item.type].push(item.diagnosis_with_code);
              return acc;
            },
            {}
          );
        });
        this.setState({ icd_group: group });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ isLoading: false, isinnerLoading: false });
      });
  }

  handleChangeSelect(val, name) {
    name = name ? name.trim() : name;
    if (!name) return;
    let temp = this.state?.[`${val}`];
    let alreadyExist = temp.filter((x) =>
      x.toLowerCase().trim() == name.toLowerCase().trim()
    );
    if (alreadyExist?.length > 0) {
      message.error(
        `${name} is already selected for the ${utils.ConvertToPascalCase(val)}`, ErrorDuration
        
      );
      this.form.current?.setFieldsValue({ [`${val}`]: [] });
      return;
    }
    temp.push(name);
    if (name && name?.trim().length > 0) {
      this.setState({ [`${val}`]: temp });
      this.form.current?.setFieldsValue({ [`${val}`]: [] });
    }
    typeof this.props.formAction == "function" && this.props.formAction(true); 
  }
  removeTag(val, name) {
    let temp = this.state?.[`${val}`];
    if (temp.includes(name)) {
      let value = temp.indexOf(name);
      temp.splice(value, 1);
      this.setState({ [`${val}`]: temp });
      this.form.current?.setFieldsValue({
        [`${val}`]: this?.state?.[`${val}`],
      });
    }
  }

  onFinish(values) {
    // this.descructurecheckbox()
    values.appointment_id = this.props?.data?.appointment_id;
    values.type = this.props?.type || this.props?.data?.user_type;
    // values.finding_from_dsm = this.state.diagnosis_question_list?.finding_from_dsm
    // || [];
    values.provisional_diagnosis = this.state.provisional_diagnosis || [];
    if(values.provisional_diagnosis.length<1){
      message.warning("Missing Provisional Diagnostic")
      return;
    }
    this.setState({buttonLoading: true})
    // values.differential_diagnosis = this.state.differential_diagnosis || [];
    // values.final_diagnosis = this.state.final_diagnosis || [];
    values.is_completed = true;
    // values.final_diagnosis_check_box = this.state.checkbox_options || [];
    api.save_new_diagnosis(values).then((res) => {
      if (res.data?.status == 200) {
        message.success(res.data?.message, ErrorDuration);
        this.setState({
          isLoading: false,
          submittedDiagnosis: true,
          form_disable: true,
          update_diagnosis: true,
          buttonLoading: false
        });
        typeof this.props.formAction == "function" &&
          this.props.formAction(false);
        typeof this.props.updateDrawerData == "function" &&
          this.props?.updateDrawerData();
      }
    });
  }
  clearState(state) {
    this.setState({ [`${state}`]: [] });
  }
//   tagRender = (val) => {
//     let color = "";
//     Object.keys(this.state.icd_group).map((i) => {
//       if (this.state.icd_group[i].includes(val.label)) {
//         if (i == "DSM_5") {
//           color = "green";
//         } else if (i == "ICD_11") {
//           color = "yellow";
//         }
//       }
//     });
//     const { label, value, closable, onClose } = val;
//     const onPreventMouseDown = (event) => {
//       event.preventDefault();
//       event.stopPropagation();
//     };
//     return (
//       <Tag
//         color={color}
//         onMouseDown={onPreventMouseDown}
//         closable={closable}
//         onClose={onClose}
//         style={{ fontSize: "14px", margin: "3px " }}
//       >
//         <Text>{val.label}</Text>
//       </Tag>
//     );
//   };
  onTodoRemoval = (selectedState, removeData) => {
    let updatedState = this.state[`${selectedState}`].filter(
      (s) => s !== removeData
    );
    this.setState({ [selectedState]: updatedState });
  };
  handleOnSearch = (data,i) => {
    this.setState({fetching: true });
    if (data) {
      this.debouncedFunction(data, i);
    } 
  };
  debouncedFunction = debounce((data, field) => {
    api
      .get_icd_list(data)
      .then((res) => {
        let icd_suggest = res.data.data.results.map((i) => {
          return {
            type: i.type,
            diagnosis: i.diagnosis,
            code: i.code,
            diagnosis_with_code: i.code
              ? i.diagnosis + "(" + i.code + ")"
              : i.diagnosis,
          };
        });
        
        this.setState({ [`${field}_1`]: icd_suggest,fetch:false});
        let group = [];
        Object.values(this.state.icd_suggession).map((i, j) => {
          group = Object.values(this.state.icd_suggession).reduce(
            (acc, item) => {
              if (!acc[item.type]) {
                acc[item.type] = [];
              }
              acc[item.type].push(item.diagnosis_with_code);
              return acc;
            },
            {}
          );
        });
        this.setState({ icd_group: group });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ isLoading: false, isinnerLoading: false });
      });
  }, 800);

  descructurecheckbox (){
      this.state.checkbox_options.map((m)=>{
        m.is_selected = this.state.selected_array?.includes(m.name) ? true : false
      })
      if(this.state.checkbox_length == 6){
        this.setState({final_diagnosis: this.state.final_diagnosis})
      }
      else{
        this.setState({final_diagnosis: []})
      }

  }
  handleCheckboxFinalDiagnosis = (val, checked) => {
    this.setState((prevState) => {
      const { final_diagnosis, selected_array } = prevState;
      const updatedArray = final_diagnosis.length === 0
        ? (checked ? [...selected_array, val] : selected_array.filter((item) => item !== val))
        : ((checked || this.state.checkbox_length == 6)? [...selected_array, val] : selected_array.filter((item) => item !== val));
  
      const checkbox_length = updatedArray.length;
      const enable_finalDiagnosis = checkbox_length == 6? false: true;
    return {
      selected_array: updatedArray,
      finalDiagnosis_checkbox: val,
      checkbox_length,
      enable_finalDiagnosis,
      checkbox_checked: checked,
    };
    });
  };
  handleOnConfirm = (val) =>{
      const updatedSelectedArray = this.state.selected_array.filter(item => item !== val);
      this.setState({
        selected_array: updatedSelectedArray,
        enable_finalDiagnosis: true,
        checkbox_length: updatedSelectedArray.length
      });
  }
  render() {
    // console.log("State Value");
    // console.log(this.state);
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div style={this.props.style || {}} className="diagnosis-wrapper">
            <>
              <Form
                onFinish={this.onFinish.bind(this)}
                ref={this.form}
                colon={false}
                labelWrap
                labelAlign="left"
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                requiredMark={false}
                onFieldsChange={(val) =>
                  typeof this.props.formAction == "function" &&
                  this.props.formAction(true)
                }
                scrollToFirstError={{
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }}
                className="diagnosis-form"
              >
                <div className="diagnosis-block">
                  {Object.keys(this?.state?.diagnosis_question_list || []).map(
                    (i, key) => {
                      if (key == 0)
                        return (
                          <div>
                            <Divider orientation="left">
                              {utils.ConvertToPascalCase(i)}
                            </Divider>
                            {/* {  (this.state?.provisional_diagnosis_1 || []
                                ).map((o, i) => (
                        
                                   <p>
                                      {o?.diagnosis_with_code}
                                      </p>))} */}
                            
                            <Form.Item
                              key={i}
                              // label={utils.ConvertToPascalCase(i)}
                              name={i}
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 24 }}
                              className="suggest-select"
                              style={{
                                display: "contents",
                                textDecoration: "underline",
                              }}
                            >
                              <Select
                                placement="bottomLeft"
                                showSearch
                                filterOption={false}
                                getPopupContainer={(trigger) => trigger.parentNode}
                                aria-autocomplete="false"     
                                allowClear
                                disabled={key==3 && this.state.enable_finalDiagnosis}
                                autoClearSearchValue={true}
                                 onChange={this.handleChangeSelect.bind(this, i)}
                                // maxTagCount={1}
                                // options={this.state.provisional_diagnosis_1}
                                style={{
                                  width: "100%",
                                  paddingLeft: "0px !important",
                                }}
                                onClick={(e) => {
                                     this.getDefaultIcdList(e,i)
                                }}
                                placeholder={"Search by Diagnosis..."}
                                popupClassName="bottom-positioned-dropdown"
                                onSearch={(e) => {
                                    this.handleOnSearch(e, i);
                                  if (e.length > 0) {
                                    this.setState({
                                      newOption: e,
                                      selected_name: "",
                                    });
                                  
                                  }
                                }}
                              >
                                {this.state.newOption &&
                                  this.state.icd_suggession.filter(
                                    (o) => o === this.state.newOption
                                  ).length === 0 && (
                                    <Option
                                      key={this.state.newOption}
                                      value={this.state.newOption}
                                    >
                                      {this.state.newOption}
                                    </Option>
                                  )} 
                                
                              
                                {this.state[`${i}_1`] &&
                                  this.state[`${i}_1`].map((o, i) => {
                                    return (
                                      <Select.Option
                                        value={o.diagnosis_with_code}
                                        key={i}
                                        label={o.diagnosis}
                                      >
                                        {/* {o.diagnosis_with_code} */}
                                      </Select.Option>
                                    );
                                  })}
                                
                              </Select>
                            </Form.Item>
                            {this.state[`${i}`].length > 0 && (
                              <List
                                //   header={<div>Header</div>}
                                //   footer={<div>Footer</div>}
                                style={{ marginTop: "12px" }}
                                bordered
                                dataSource={this.state[`${i}`] || []}
                                className={(key==3 && this.state.enable_finalDiagnosis) ? "todo-class-diagnosis" : ""}
                                renderItem={(item) => {
                                  if(key==3 && this.state.enable_finalDiagnosis){
                                    return null
                                  } 
                                  else{
                                    return(
                                      <TodoItem
                                      key={item}
                                      todo={item}
                                      onTodoRemoval={this.onTodoRemoval.bind(
                                        this,
                                        i
                                      )}
                                      icd_suggession={
                                        this.state?.icd_suggession || []
                                      }
                                    />
                                    )
                                  }
                                }
                              }
                              />
                            )}
                          </div>
                        );
                    }
                  )}
                </div>
              </Form>
              {this.state.is_editable && 
              <div
                style={{ margin: "20px 0px", float: "right" }}
                className="submit-button-wrapper-drawerMse"
              >
                <SubmitButton
                 label={this.state.update_diagnosis ? `${CONSTANTS.UPDATE}`: `${CONSTANTS.SUBMIT}`}
                 className={"update-btn"}
                 onClick={(e) => {
                  this.form.current?.submit(),
                    this.props?.from == "drawer_diagnosis"
                      ? this.setState({ isLoading: false })
                      : null;
                  }}
                 loading={this.state.buttonLoading}
              />
            </div>}
            </>
          </div>
        )}
      </>
    );
  }
}

const mapDispatchToProps = {
  currentTab,
};
export default connect(null, mapDispatchToProps)(Diagnosis);
